import { BookListPage } from './BookListPage';
export default BookListPage;
